import { Text } from '@chakra-ui/react'
import { memo, useState } from 'react'
import { useBrands } from '../../../hooks/useOrganization'
import { capitalizeWords, replaceUnderscore } from '../../../utils/functions/formatters'
import SelectAsInput from './SelectAsInput'

interface Item {
  id: string
  name: string
  image: string | undefined | null
}

interface RawItem {
  id: string
  name: string
  logo: string | undefined | null
}
interface FormBrandSelectProps {
  value: Item | null
  onAdd: (item: Item) => void
  onRemove?: () => void
  memberId?: string
  spliceName?: boolean
  name: string
  labelOverride?: string
  isDisabled?: boolean
  showLabel?: boolean
  filterParams?: Record<string, any>
  w?: string
  h?: string
}

const FormBrandSelect = ({
  value,
  onAdd,
  onRemove,
  memberId,
  spliceName,
  name,
  labelOverride,
  isDisabled,
  showLabel = true,
  filterParams = {},
  w = '100%',
  h = '40px',
}: FormBrandSelectProps) => {
  const [brandSearch, setBrandSearch] = useState('')

  const brands = useBrands({ search: brandSearch, member: memberId, page: 1, fields: 'id,name,country,logo', page_size: 20, ...filterParams })

  return (
    <>
      {showLabel && (
        <Text color="neutral.500" fontWeight="600" fontSize="12px" letterSpacing="0.5px" mb="8px">
          {labelOverride ?? capitalizeWords(name)}
        </Text>
      )}
      <SelectAsInput
        isDisabled={isDisabled}
        h={h}
        w={w}
        value={value}
        onChange={(v) => {
          if (v)
            onAdd({
              id: v.id,
              name: spliceName ? v.name.slice(0, -3) : v.name,
              image: v.image,
            })
          if (!v && onRemove) onRemove()
        }}
        search={brandSearch}
        onSearchChange={(v) => setBrandSearch(v)}
        options={
          brands.data?.data?.map((item: RawItem) => ({
            id: item.id,
            name: item.name,
            image: item.logo,
          })) || []
        }
        isLoading={brands.isFetching}
        placeholder={`Search for a ${replaceUnderscore(name)}`}
        fontSize="xs"
      />
    </>
  )
}

export default memo(FormBrandSelect)
